import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "feature-limited-time-3zeZT",
  "use": "feature-limited-time-3zeZT-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"feature-limited-time-3zeZT\"><g fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" d=\"M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm0 1a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13z\" /><path d=\"M6.618 7H7V3H6v4h.191l-.362.724L8.724 9.17l.447-.895L6.618 7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol